import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RequestDescUpdateModalUI from './RequestDescUpdateModalUI.js'

class RequestDescUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      requestDescription: this.props.loan.loanRequest.requestDesc || '',
      requestDescriptionError: null,
    }
  }

  render() {
    return (
      <RequestDescUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        requestDescription={this.state.requestDescription}
        onRequestDescriptionChange={(event) => { this.setState({ requestDescription: event.target.value }) }}
        requestDescriptionError={this.state.requestDescriptionError}
        setRequestDescriptionError={(error) => { this.setState({ requestDescriptionError: error }) }}
      />
    )
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }

  onCancelClick = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      requestDescriptionError: null,
    })
    this.props.onCancelClick()
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/requestDescription`,
      this.onSubmitCallback, {
      requestDescription: this.state.requestDescription,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'requestDescription':
          this.setState({ requestDescriptionError: error.message })
          break
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.success) {
      this.props.onRefreshClick()
      this.onCancelClick()
    }
  }
}

export default RequestDescUpdateModalSF
